/* unplugin-vue-components disabled */import { render } from "./w-dialog.vue?vue&type=template&id=338ada3e&ts=true"
import script from "./w-dialog.vue?vue&type=script&lang=ts"
export * from "./w-dialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__